import { jsx as _jsx } from "react/jsx-runtime";
import { Text } from '../Text/Text';
import { Box } from '../layout/Box';
import { FlexContainer } from '../layout/FlexContainer';
import { PageButton } from './PageButton';
import { calculatePageDefinitions } from './calculatePageDefinitions';
const PagePlaceholder = () => (_jsx(Box, { spacingHorizontal: true, children: _jsx(Text, { children: "..." }) }));
export const Pagination = ({ totalPageCount, currentPage, onPageChange, }) => {
    const pageDefinitions = calculatePageDefinitions({
        totalPageCount,
        currentPage,
    });
    const pageButtons = pageDefinitions.map(({ type, page }) => {
        const isActive = page === currentPage;
        const handlePageClick = () => {
            onPageChange(page);
        };
        const componentMap = {
            placeholder: _jsx(PagePlaceholder, {}, page),
            page: (_jsx(PageButton, { page: page, active: isActive, onClick: handlePageClick }, page)),
        };
        return componentMap[type];
    });
    return _jsx(FlexContainer, { gap: '1/2', children: pageButtons });
};
